import { buildApiUrl } from '../config/api';

const NICKNAME_RE = /^[a-z0-9._-]{3,32}$/;

function randomAlphanum(len) {
  const chars = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let s = '';
  try {
    const arr = new Uint8Array(len);
    crypto.getRandomValues(arr);
    for (let i = 0; i < len; i += 1) s += chars[arr[i] % chars.length];
  } catch {
    for (let i = 0; i < len; i += 1) s += chars[Math.floor(Math.random() * chars.length)];
  }
  return s;
}

/** Кандидат в никнейм: латиница/цифры, 3–32 символа, уникальность проверяется отдельно */
export function makeRandomNicknameCandidate() {
  const t = Date.now().toString(36);
  const r = randomAlphanum(8);
  let nick = `u${t}${r}`;
  nick = nick.toLowerCase().replace(/[^a-z0-9._-]/g, '');
  if (nick.length > 32) nick = nick.slice(0, 32);
  if (nick.length < 3) nick = `u${randomAlphanum(12)}`.slice(0, 32);
  return nick;
}

export async function isNicknameAvailable(nickname) {
  const trimmed = (nickname || '').toString().trim().toLowerCase();
  if (!NICKNAME_RE.test(trimmed)) return false;
  const resp = await fetch(
    buildApiUrl(`/users/check-nickname?nickname=${encodeURIComponent(trimmed)}`),
    { credentials: 'include' }
  );
  if (!resp.ok) return false;
  const data = await resp.json().catch(() => ({}));
  return data.available === true;
}

/**
 * Подбирает свободный никнейм (для клиентов / регистрации тренера).
 * @param {number} maxAttempts
 * @returns {Promise<string>}
 */
export async function generateUniqueRandomNickname(maxAttempts = 40) {
  for (let i = 0; i < maxAttempts; i += 1) {
    const candidate = makeRandomNicknameCandidate();
    if (await isNicknameAvailable(candidate)) return candidate;
  }
  throw new Error('Не удалось подобрать уникальный никнейм. Попробуйте ещё раз.');
}
